export default __webpack_public_path__ + "img/eWGCwHxC.3341c05d.svg";